function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import adClient from './client/ad-client';
import { ensureTitan, requestAds } from './util/titan';
import sortRequests from './util/sorting'; // Do this once before anything else to ensure we're all setup and ready to go

import { jsx as ___EmotionJSX } from "@emotion/core";
ensureTitan();
export var childContextTypes = {
  noAds: PropTypes.bool,
  registerAdSpot: PropTypes.func
};

function doBatchCallAndUpdate(batch) {
  // eslint-disable-next-line no-param-reassign
  batch.pending = false;

  if (batch.titanRequests.length) {
    var titanRequests = sortRequests(batch.titanRequests).map(function (_ref) {
      var adId = _ref.adId,
          callback = _ref.callback;
      return [adId, callback];
    });
    requestAds(titanRequests); // Now that these particular IDs have been handled, clear out the array
    // eslint-disable-next-line no-param-reassign

    batch.titanRequests.length = 0;
  }

  if (batch.inlineAdRequests.length) {
    batch.inlineAdRequests.map(function (_ref2) {
      var adUrl = _ref2.adUrl,
          callback = _ref2.callback;
      return adClient(adUrl).then(function (data) {
        return callback(data);
      });
    }); // Now that these particular inlineAds have been handled, clear out the array
    // eslint-disable-next-line no-param-reassign

    batch.inlineAdRequests.length = 0;
  }
}

export var AdRoot = /*#__PURE__*/function (_React$Component) {
  _inherits(AdRoot, _React$Component);

  var _super = _createSuper(AdRoot);

  function AdRoot() {
    var _this;

    _classCallCheck(this, AdRoot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "eventListener", function () {
      doBatchCallAndUpdate(_this._batchCalls['window.onload']);
    });

    _defineProperty(_assertThisInitialized(_this), "_batchCalls", {
      immediate: {
        titanRequests: [],
        inlineAdRequests: [],
        pending: false
      },
      requestAnimationFrame: {
        titanRequests: [],
        inlineAdRequests: [],
        pending: false
      },
      'window.onload': {
        titanRequests: [],
        inlineAdRequests: [],
        pending: false
      }
    });

    _defineProperty(_assertThisInitialized(_this), "registerAdSpot", function (_ref3, callback) {
      var adId = _ref3.adId,
          adUrl = _ref3.adUrl,
          strategy = _ref3.strategy,
          after = _ref3.after;
      var batch = _this._batchCalls[strategy];

      if (adId) {
        batch.titanRequests.push({
          adId: adId,
          callback: callback,
          after: after
        });
      } else {
        batch.inlineAdRequests.push({
          adUrl: adUrl,
          callback: callback,
          after: after
        });
      }

      if (!batch.pending) {
        batch.pending = true; // Allow registering _after_ the component has mounted
        // In particular: This root component may have mounted previously, but an
        // <AdSpot> component is only just now being mounted due to a
        // react-responsive change, etc. It too needs to execute the below.
        // NOTE: Using setTimeout with a `0` delay will actually delay by 4ms, but
        // is the only cross-browser / server way to put things at the end of the
        // event loop

        setTimeout(function () {
          return doBatchCallAndUpdate(batch);
        }, 0);
      }
    });

    return _this;
  }

  _createClass(AdRoot, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        noAds: this.props.noAds,
        registerAdSpot: this.registerAdSpot
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._batchCalls.immediate.pending = true;
      this._batchCalls.requestAnimationFrame.pending = true;
      this._batchCalls['window.onload'].pending = true; // immediately reset the array so we don't accidentally re-trigger a load
      // for these same titanRequests in the future

      doBatchCallAndUpdate(this._batchCalls.immediate);
      window.requestAnimationFrame(function () {
        // Now that these particular IDs have been handled, clear out the array
        doBatchCallAndUpdate(_this2._batchCalls.requestAnimationFrame);
      });
      window.addEventListener('load', this.eventListener);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('load', this.eventListener);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return AdRoot;
}(React.Component);
AdRoot.propTypes = {
  noAds: PropTypes.bool.isRequired,
  children: PropTypes.node
};
AdRoot.defaultProps = {
  children: null
};
AdRoot.childContextTypes = childContextTypes;

var withAdRoot = function withAdRoot(_ref4) {
  var noAds = _ref4.noAds;
  return function (WrappedComponent) {
    var WithAdRoot = function WithAdRoot(props) {
      return ___EmotionJSX(AdRoot, {
        noAds: noAds
      }, ___EmotionJSX(WrappedComponent, props));
    };

    setHOCDisplayName(WithAdRoot, WrappedComponent, 'withAdRoot');
    return WithAdRoot;
  };
};

export default withAdRoot;